/**
 * awsCache模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const awsCache = {
  //分页
  page(params) {
    return $http.post(`${global.API_URL}/sme/awsCache/page`,params);
  },
  //查看elasticache详情
  getAwsCacheDetailById(params) {
    return $http.post(`${global.API_URL}/sme/awsCache/getAwsCacheDetailById`,params);
  },
  //查询elasticache列表
  queryResourceAwsCacheByGroup(params) {
    return $http.post(`${global.API_URL}/sme/awsCache/queryResourceAwsCacheByGroup`,params);
  },
  //查询elasticache列表
  listResourceAliRedisDTOByAliApi(params) {
    return $http.post(`${global.API_URL}/sme/awsCache/listResourceAliRedisDTOByAliApi`,params);
  },
  //查询 GCPelasticache列表
  listResourceGcpRedisDTOByAliApi(params) {
    return $http.post(`${global.API_URL}/sme/gcpRedis/listResourceGcpRedisDTOByAliApi`,params);
  },

  //删除
  delete(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/awsCache/delete`,param);
  }
}

export default awsCache;



// WEBPACK FOOTER //
// ./src/api/awsCache.js